import { useState } from 'react';
import { faqs } from '@/mocks/manhwa';

const faqSchema = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: faqs.map((f) => ({
    '@type': 'Question',
    name: f.q,
    acceptedAnswer: { '@type': 'Answer', text: f.a },
  })),
};

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }} />
      <div className="mx-auto w-full max-w-3xl px-4 md:px-6">
        <div className="mb-8 text-center">
          <h2 className="font-heading text-2xl text-foreground-950 md:text-3xl">常见问题</h2>
          <p className="mt-2 text-sm text-foreground-600">关于漫画韩国下拉式的追更、阅读与支持，你想知道的都在这里。</p>
        </div>

        <div className="space-y-3">
          {faqs.map((f, i) => {
            const isOpen = open === i;
            return (
              <div key={f.q} className="overflow-hidden rounded-lg bg-background-100/70">
                <button
                  onClick={() => setOpen(isOpen ? null : i)}
                  aria-expanded={isOpen}
                  className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left transition-colors hover:bg-background-100"
                >
                  <span className="font-bold text-foreground-950">{f.q}</span>
                  <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-background-50 text-foreground-600 transition-transform ${isOpen ? 'rotate-45' : ''}`}>
                    <i className="ri-add-line" />
                  </span>
                </button>
                {isOpen && (
                  <div className="px-5 pb-5">
                    <p className="border-t border-background-200 pt-4 text-sm leading-relaxed text-foreground-700">{f.a}</p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}